import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { byName, toCbBranch } from './branch-shape';

/** `GET /client/:cid/branch`, in name order as cb returned it (no 3PL partner). */
export const getBranches = async (): Promise<any[]> => {
  const branches = await lpRequest('GET', clientPath('/branch'));

  return (branches || []).map((branch: any) => toCbBranch(branch)).sort(byName);
};
